<template>
  <v-app>
    <transition name="router-anim" :enter-active-class="$route.meta.transition == false ? null : 'animated fadeIn'">
      <router-view/>
    </transition>
    <v-snackbar v-model="snackbar" top right :timeout="4000" multi-line color="error">
      <v-icon color="white">cloud_off</v-icon>
      <div style="margin-left: 15px">{{ getGlobalNotification.snack }}</div>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters , mapActions } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
const AuthRepository = RepositoryFactory.get('auth');

export default {
  data: () => ({
    drawer: null,
    snackbar: false,
    CadastroItens: [
      { title: 'Escola', icon: 'label', rt: '/escola' },
      { title: 'Disciplina', icon: 'label', rt: '/disciplina' },
      { title: 'Área de Conhecimento', icon: 'label', rt: '/area-de-conhecimento' },
      { title: 'Corte Etário', icon: 'label', rt: '/corte-etario' },
      { title: 'Tipo de Sala', icon: 'label', rt: '/tipo-de-sala' },
      { title: 'Sala por Escola', icon: 'label', rt: '/sala-escola' },
      { title: 'Etapa Escolar', icon: 'label', rt: '/etapa-escolar' },
      { title: 'Atividade Avaliativa', icon: 'label', rt: '/atividade-avaliativa' },
      { title: 'Distribuir Notas', icon: 'label', rt: '/distribuir-notas' },
      { title: 'Etapa Escolar Ofertada na Escola', icon: 'label', rt: '/area-de-conhecimento' },
      /* { title: 'Tipo de Sala', icon: 'label', rt:'/tipo-de-sala' },
        { title: 'Sala por Escola', icon: 'label', rt:'/sala-escola' } */
    ],
    items: [
      { title: 'Minha Conta' },
      { title: 'Configurações' },
      { title: 'Sair' },
    ],
  }),
  async created() {
    this.$store.watch((state, getters) => getters.getGlobalNotification.snack, (newVal) => {
      if(newVal !== '') {
        this.snackbar = true;
      } 
    });
    try {
      const { data } = await AuthRepository.getCheckConnection();
    } catch (error) { }
  },
  watch: {
    snackbar(newVal) {
      if(!newVal) { this.$store.dispatch('adicionarNotificacao', ''); }
    },
  },
  computed: {
    ...mapGetters(['getGlobalNotification']),
  },
};
</script>

<style lang="scss">
.app-nav {
  text-align: center;
}
.app-nav img{
  margin-top: 4px;
}
.border-avatar{
  border: 2px solid #508fbf;
}
</style>
